
import React from 'react';
import { UserManagement } from '@/components/admin/UserManagement';

const AdminUsers = () => {
  return <UserManagement />;
};

export default AdminUsers;
